
import "./App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { Main } from "./router/main/Main";
import styled from "styled-components";
import LogoMark from "./assets/image/logo.png";
import { TestMain } from "./router/test-main/TestMain";
import { Test } from "./router/test/Test";
import { Result } from "./router/result/Result";
import { useState } from "react";

const App = () => {
  const [openMenu, updateOpenMenu] = useState(false);

  return (
    <BrowserRouter>
      <Container>
        <LayoutContainer>
          <BodyContainer>
            <MainHeader>
              <div className="group" style={{ gap: 14 }}>
                
              </div>
              <Link to={"/"} style={{ textDecoration: "none" }}>
                <LogoText>
                  <span style={{ color: "#191919" }}>바싹 마른</span>
                  <span style={{ color: "#FF8000" }}> 망고 </span>
                  <img src={LogoMark} alt="" style={{ height: "1em", marginLeft: 8, verticalAlign: "middle" }} />
                </LogoText>
              </Link>
              <div className="group" style={{ gap: 14, opacity: 0 }}>
                
              </div>
            </MainHeader>
            <MainBody>
              <Routes>
                <Route path="/" element={<Navigate to="/test-main/1" replace />} />
                <Route path="/test-main/:id" element={<TestMain />} />
                <Route path="/test-main/:id/test" element={<Test />} />
                <Route
                  path="/main-test/:id/result/:count"
                  element={<Result />}
                />
              </Routes>
            </MainBody>
          </BodyContainer>
          
          
        </LayoutContainer>
      </Container>
    </BrowserRouter>
  );
};

const Container = styled.div`
  width: 100vw;
  height: 100vh;

  background-color: white;
  box-sizing: border-box;
`;

const LayoutContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 448px;
  height: 100%;
  min-height: 100vh;
  margin: 0 auto;

  border-left: 1px solid black;
  border-right: 1px solid black;

  overflow: hidden;
  .main__body {
  }
`;

const BodyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  overflow: scroll;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

const Dimd = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10;
`;

const Sidemenu = styled.div`
  position: absolute;
  top: 0;
  left: -80%;
  width: 80%;
  height: 100%;
  background-color: white;
  z-index: 11;

  display: flex;
  flex-direction: column;

  transition: all 0.2s ease;

  &.side__menu__open {
    left: 0;
  }
`;

const SideInfo = styled.div`
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  color: #133337;

  font-size: 32px;
  font-style: normal;
  font-weight: 200;
  letter-spacing: -0.14px;
`;

const LinkItem = styled.a`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 38px;

  text-decoration: none;

  color: #1f2022;

  /* heading/14-md */

  font-size: 16px;
  font-style: normal;
  font-weight: 200;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.14px;
`;

const MainHeader = styled.div`
  height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0px 12px 0px;
  .group {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .logo {
    width: 150px;
    cursor: pointer;
  }

  .btn {
    cursor: pointer;
  }
`;

const MainBody = styled.div`
  width: 100%;
  height: 100%;
  overflow: scroll;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

const LogoText = styled.div`
  font-size: 22px;
  font-style: normal;
  font-weight: 200;
  line-height: 28px; /* 155.556% */
  letter-spacing: -1.2px;
`;

export default App;